// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"332":"PostSale","339":"Checkout"}[chunkId] || chunkId) + "." + {"52":"dfe9ec51","196":"6cf8b1ac","332":"6709d64e","339":"08ce2d5f","345":"9e512a54","525":"38d2f0bd","647":"b3da3d63","727":"523ce96d","834":"ec456a97","995":"273ae10f"}[chunkId] + ".chunk.js";
};